import styled from "styled-components";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";

export {
  Backdrop,
  Pane,
  PaneHeader,
  PaneTitle,
  CloseBtn,
  PaneDescription,
  PaneFooter,
} from "./analytics.pane.styles";

export const DaysList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 16px 24px;
  overflow-y: auto;
  flex: 1;
`;

export const DayRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 16px;
  border: 1.5px solid ${ColorV2.Blue6};
  border-radius: 12px;
  background: ${ColorV2.White};
`;

export const DayRowTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const DayName = styled.span`
  ${TypographyV2.s1}
  color: ${ColorV2.Blue1};
`;

export const Toggle = styled.button<{ $enabled: boolean }>`
  position: relative;
  width: 40px;
  height: 22px;
  border-radius: 11px;
  border: none;
  cursor: pointer;
  background: ${({ $enabled }) =>
    $enabled ? ColorV2.ElectricBlue : ColorV2.Blue5};
  transition: background 0.2s;
  flex-shrink: 0;
  padding: 0;

  &:focus-visible {
    outline: 2px solid ${ColorV2.ElectricBlue};
    outline-offset: 2px;
  }
`;

export const ToggleKnob = styled.span<{ $enabled: boolean }>`
  position: absolute;
  top: 3px;
  left: ${({ $enabled }) => ($enabled ? "21px" : "3px")};
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: ${ColorV2.White};
  transition: left 0.2s;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
`;

export const DayRowSelects = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  align-items: flex-end;
`;

export const SelectGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 100px;
`;

export const SelectLabel = styled.span`
  ${TypographyV2.s1}
  color: ${ColorV2.Blue4};
`;

export const HourSelect = styled.select`
  ${TypographyV2.b2}
  color: ${ColorV2.Blue1};
  background: ${ColorV2.White};
  border: 1.5px solid ${ColorV2.Blue5};
  border-radius: 10px;
  padding: 8px 12px;
  appearance: none;
  cursor: pointer;
  width: 100%;
  outline: none;

  &:focus {
    border-color: ${ColorV2.ElectricBlue};
  }

  &:hover {
    border-color: ${ColorV2.Blue4};
  }
`;

export const OvernightNote = styled.span`
  ${TypographyV2.s1}
  color: ${ColorV2.Blue3};
  align-self: flex-end;
  padding-bottom: 9px;
`;

export const ClosedNote = styled.span`
  ${TypographyV2.s1}
  color: ${ColorV2.Blue4};
`;
